export default __webpack_public_path__ + "static/media/vuesax-linear-profile.c281a67f.svg";